import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  FlatList,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import Header from "../../../commonComponents/Header";
import LeaderBoard from "../childComponents/LeaderBoard";
import Colors from "../../../assets/Color/Colors";
import { globalImport } from "../../../common/globalImports";
import { Network } from "../../../utils/network";
import ContestClosedCard from "../childComponents/ClosedDetailCard";
import ContestAboutBox from "../childComponents/ContestAboutBox";
import { useSelector } from "react-redux";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData} from "../../../utils/globalConstant";

const ContestTabsNew = ["Event Outcomes", "Performance"];
const ContestTabsOld = ["Event Outcomes", "LeaderBoard"];

const ContestLeaderBoard = ({ navigation, route }) => {
  const contestId = route?.params?.contestId;
  const contestConfig = useSelector(
    (state) => state.utilReducer.globalConfigData?.contestConfig
  );
  const contestDetails = route?.params?.contestDetails;
  const isNewFormat = contestDetails?.contest_format === "format2";
  const ContestTabs = isNewFormat
    ? true
      ? ContestTabsNew
      : ["Event Outcomes"]
    : ContestTabsOld;
  const [selectedTab, setSelectedTab] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [contestClosedDetails, setContestClosedDetails] = useState([]);

  useEffect(() => {
    getClosedDetails();
  }, []);

  const getClosedDetails = async () => {
    setLoading(true);
    const res = await Network.getContestClosedDetails(contestId);
    if (res?.data?.success) {
      setContestClosedDetails(res?.data?.events);
    }
    setLoading(false);
  };

  const onTabClick = (index) => {
    if (selectedTab !== index) {
      setSelectedTab(index);
    }
  };

  const renderFantasyCard = ({ item, index }) => {
    return (
      <View key={index}>
        <ContestClosedCard contestDetails={item} />
      </View>
    );

    // return <ArticleCardWithImage items={item} handleArticlePress={handleArticlePress} />;
  };

  const renderFooter = () => {
    return (
      <View
        style={{
          padding: 10,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        {isLoading ? (
          <ActivityIndicator size="large" color={globalConfigurableData.loaderColor} />
        ) : null}
      </View>
    );
  };

  return (
    <SafeAreaView style={[globalStyle.pageContainer, { flexGrow: 1 }]}>
      <Header
        isInternalPage={false}
        navigation={navigation}
        pageName={isNewFormat ? "" : "LeaderBoard"}
        backGroundColor={"#FFFFFF"}
        translate={true}
        // contestBalance={
        //   isNewFormat ? contestDetails?.final_wallet_amount : false
        // }
      />
      <ContestAboutBox
        contestDetail={contestDetails}
        isNewFormat={isNewFormat}
      />
      <View
        style={{
          flexDirection: "row",
          marginHorizontal: 15,
          marginTop: 20,
        }}
      >
        {ContestTabs.map((item, index) => {
          const isSelected = index === selectedTab;
          return (
            <TouchableOpacity
              onPress={() => {
                onTabClick(index);
              }}
              style={[
                globalStyle.outerElementBox,
                styles.headerOption,
                isSelected ? styles.headerOptionsSelected : {},
              ]}
            >
              <FormTextLabel
                labelStyles={[
                  styles.tabText,
                  isSelected ? { color: Color.bgWhite } : null,
                ]}
                label={item}
              />
            </TouchableOpacity>
          );
        })}
      </View>
      <View style={{ paddingHorizontal: 15, paddingTop: 20, flex: 1 }}>
        {selectedTab === 1 && (
          <LeaderBoard
            contestId={contestId}
            isClosedContest={true}
            isNewFormat={isNewFormat}
          />
        )}
        {selectedTab === 0 && (
          <View style={{ marginTop: -15 }}>
            <FlatList
              contentContainerStyle={{
                paddingBottom: contestClosedDetails.length === 0 ? 0 : 350,
              }}
              //columnWrapperStyle={{ flex: 1 }}
              data={contestClosedDetails}
              renderItem={renderFantasyCard}
              onRefresh={getClosedDetails}
              refreshing={isLoading}
              keyExtractor={(item, index) => item.id}
              showsVerticalScrollIndicator={false}
              initialNumToRender={10}
              updateCellsBatchingPeriod={15}
              ListFooterComponent={globalImport.isWeb ? renderFooter : <></>}
            />
          </View>
        )}
      </View>
    </SafeAreaView>
  );
};

export default ContestLeaderBoard;

const styles = StyleSheet.create({
  tabText: {
    ...globalFontStyle.appFontSubHeading,
    color: Color.black2,
    textAlign: "center",
  },
  headerOption: {
    paddingHorizontal: 15,
    height: 40,
    marginRight: 10,
  },
  headerOptionsSelected: {
    backgroundColor: Colors.black,
  },
});
